//
// Copyright © 2026 Intabia Fusion.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import type { Class, Ref } from '@hcengineering/core'
import type { Plugin } from '@hcengineering/platform'
import { plugin } from '@hcengineering/platform'
import type { DocumentPresence, TypingIndicator, WorkspacesNotification } from './types'

/** @public */
export const pulseId = 'pulse' as Plugin

/** @public */
const pulsePlugin = plugin(pulseId, {
  class: {
    DocumentPresence: '' as Ref<Class<DocumentPresence>>,
    TypingIndicator: '' as Ref<Class<TypingIndicator>>,
    WorkspacesNotification: '' as Ref<Class<WorkspacesNotification>>
  }
})

export default pulsePlugin
